import { useContext, useState } from 'react';

import AccountManagementCanvasData from './AccountManagementCanvasData';

import { AccountManagementCanvasStateContext } from './AccountManagementCanvasContextProvider';

const useAccountManagementCanvasData = () => {
  const [accountManagementCanvasState, setAccountManagementCanvasState] = useContext(AccountManagementCanvasStateContext);

  const getAccountManagementCanvasByUserAccountId = (userAccountId) => {
    return AccountManagementCanvasData.getAccountManagementCanvasByUserAccountIdData(userAccountId, accountManagementCanvasState, setAccountManagementCanvasState);
  };
 
  return {
    accountManagementCanvasState,
    getAccountManagementCanvasByUserAccountId
  };
};

export default useAccountManagementCanvasData;